import Gallery from './gallery';

export default {
  init: function (selector) {
    const galleries = document.querySelectorAll(selector);

    if (galleries && galleries.length) {
      [...galleries].map(item => {
        const options = item.getAttribute('data-gallery-options') || '{}';
        const gallery = new Gallery(item, JSON.parse(options));
        gallery.init();
      });
    }
  }
};
